module.exports = __webpack_public_path__ + "static/card_1-a94d7d0c7edb6a209eabc27fc0f8ab36.png";